import React from 'react';
import { motion } from 'framer-motion';

export const Card = ({ children, className = '', onClick }: any) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={onClick ? { y: -4 } : {}}
      onClick={onClick}
      className={`
        bg-surface-light dark:bg-surface-dark 
        border border-surface-border-light dark:border-surface-border-dark 
        rounded-2xl p-4 shadow-sm transition-all
        ${onClick ? 'cursor-pointer hover:shadow-md' : ''}
        ${className}
      `}
    >
      {children}
    </motion.div>
  );
};
